const light = [
  {
    "featureType": "administrative",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#e0ecf3"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#fafafa"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
];

const mapSection = document.querySelector('.jsMapCanada');

function generateInfo (settings, countryflag = 'ca') {
  /*let can = (settings.can) ? `<svg width="22" height="23" viewBox="0 0 22 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M414.646354,25 L412.786797,28.4687561 C412.57579,28.8457528 412.19773,28.8107854 411.819671,28.6002212 L410.473401,27.9030073 L411.476796,33.230944 C411.687803,34.2043285 411.0108,34.2043285 410.676697,33.7834537 L408.327194,31.1528821 L407.945757,32.4887488 C407.90177,32.6641765 407.708369,32.848431 407.418222,32.8045529 L404.447251,32.1798187 L405.227595,35.0172212 C405.394647,35.6485756 405.52495,35.909978 405.05895,36.0764943 L404,36.5742618 L409.114336,40.72903 C409.316765,40.8861252 409.41904,41.1688308 409.346974,41.4248008 L408.899361,42.8939147 C410.660302,42.6909041 412.238133,42.3854782 413.999967,42.197376 C414.155501,42.18077 414.415883,42.4374797 414.414815,42.6177455 L414.181493,48 L415.037672,48 L414.902898,42.6292885 C414.901823,42.4490227 415.138046,42.18077 415.29358,42.197376 C417.055414,42.3854789 418.633247,42.6909041 420.394188,42.8939147 L419.946576,41.4248008 C419.87451,41.1688308 419.976784,40.8861252 420.179213,40.72903 L425.293548,36.5742618 L424.234599,36.0764943 C423.768598,35.909978 423.898902,35.6485756 424.065953,35.0172212 L424.8463,32.1798187 L421.875325,32.8045529 C421.585179,32.848431 421.391779,32.6641765 421.34779,32.4887488 L420.966354,31.1528821 L418.616852,33.7834537 C418.282748,34.2043285 417.605743,34.2043285 417.816751,33.230944 L418.820144,27.9030073 L417.473877,28.6002212 C417.095808,28.8107854 416.717758,28.8457528 416.506751,28.4687561" transform="translate(-404 -25)" fill="#0A6DB6" fill-rule="nonzero" stroke="none" stroke-width="1"/>
  </svg>` : ``;*/
  /*if (countryflag == 'ca') {
      `<svg width="22" height="23" viewBox="0 0 22 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <path d="M414.646354,25 L412.786797,28.4687561 C412.57579,28.8457528 412.19773,28.8107854 411.819671,28.6002212 L410.473401,27.9030073 L411.476796,33.230944 C411.687803,34.2043285 411.0108,34.2043285 410.676697,33.7834537 L408.327194,31.1528821 L407.945757,32.4887488 C407.90177,32.6641765 407.708369,32.848431 407.418222,32.8045529 L404.447251,32.1798187 L405.227595,35.0172212 C405.394647,35.6485756 405.52495,35.909978 405.05895,36.0764943 L404,36.5742618 L409.114336,40.72903 C409.316765,40.8861252 409.41904,41.1688308 409.346974,41.4248008 L408.899361,42.8939147 C410.660302,42.6909041 412.238133,42.3854782 413.999967,42.197376 C414.155501,42.18077 414.415883,42.4374797 414.414815,42.6177455 L414.181493,48 L415.037672,48 L414.902898,42.6292885 C414.901823,42.4490227 415.138046,42.18077 415.29358,42.197376 C417.055414,42.3854789 418.633247,42.6909041 420.394188,42.8939147 L419.946576,41.4248008 C419.87451,41.1688308 419.976784,40.8861252 420.179213,40.72903 L425.293548,36.5742618 L424.234599,36.0764943 C423.768598,35.909978 423.898902,35.6485756 424.065953,35.0172212 L424.8463,32.1798187 L421.875325,32.8045529 C421.585179,32.848431 421.391779,32.6641765 421.34779,32.4887488 L420.966354,31.1528821 L418.616852,33.7834537 C418.282748,34.2043285 417.605743,34.2043285 417.816751,33.230944 L418.820144,27.9030073 L417.473877,28.6002212 C417.095808,28.8107854 416.717758,28.8457528 416.506751,28.4687561" transform="translate(-404 -25)" fill="#0A6DB6" fill-rule="nonzero" stroke="none" stroke-width="1"/>
        </svg>`
  }
  else if(countryflag == 'in'){
      `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="23" viewBox="0 0 22 23">
      <rect width="225" height="150" fill="#f93"/><rect width="225" height="50" y="50" fill="#fff"/><rect width="225" height="50" y="100" fill="#128807"/><g transform="translate(112.5,75)"><circle r="20" fill="#008"/><circle r="17.5" fill="#fff"/><circle r="3.5" fill="#008"/><g id="d"><g id="c"><g id="b"><g id="a"><circle r="0.875" fill="#008" transform="rotate(7.5) translate(17.5)"/><path fill="#008" d="M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z"/></g><use xlink:href="#a" transform="rotate(15)"/></g><use xlink:href="#b" transform="rotate(30)"/></g><use xlink:href="#c" transform="rotate(60)"/></g><use xlink:href="#d" transform="rotate(120)"/><use xlink:href="#d" transform="rotate(-120)"/></g>
      </svg>`
  }*/
  return `<div class="tile-img tile-img--left tile-img--narrow map-scroll">
    <div class="tile-img__content tile-img__content--map">
      <div class="tile-img__tag-container">
        <span class="tile-img__tag">${ settings.category.split('-').join(' ') }</span>
        ${
            (countryflag => {
            if (countryflag == 'ca' && settings.can) {
                 return `<svg width="22" height="23" viewBox="0 0 22 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path d="M414.646354,25 L412.786797,28.4687561 C412.57579,28.8457528 412.19773,28.8107854 411.819671,28.6002212 L410.473401,27.9030073 L411.476796,33.230944 C411.687803,34.2043285 411.0108,34.2043285 410.676697,33.7834537 L408.327194,31.1528821 L407.945757,32.4887488 C407.90177,32.6641765 407.708369,32.848431 407.418222,32.8045529 L404.447251,32.1798187 L405.227595,35.0172212 C405.394647,35.6485756 405.52495,35.909978 405.05895,36.0764943 L404,36.5742618 L409.114336,40.72903 C409.316765,40.8861252 409.41904,41.1688308 409.346974,41.4248008 L408.899361,42.8939147 C410.660302,42.6909041 412.238133,42.3854782 413.999967,42.197376 C414.155501,42.18077 414.415883,42.4374797 414.414815,42.6177455 L414.181493,48 L415.037672,48 L414.902898,42.6292885 C414.901823,42.4490227 415.138046,42.18077 415.29358,42.197376 C417.055414,42.3854789 418.633247,42.6909041 420.394188,42.8939147 L419.946576,41.4248008 C419.87451,41.1688308 419.976784,40.8861252 420.179213,40.72903 L425.293548,36.5742618 L424.234599,36.0764943 C423.768598,35.909978 423.898902,35.6485756 424.065953,35.0172212 L424.8463,32.1798187 L421.875325,32.8045529 C421.585179,32.848431 421.391779,32.6641765 421.34779,32.4887488 L420.966354,31.1528821 L418.616852,33.7834537 C418.282748,34.2043285 417.605743,34.2043285 417.816751,33.230944 L418.820144,27.9030073 L417.473877,28.6002212 C417.095808,28.8107854 416.717758,28.8457528 416.506751,28.4687561" transform="translate(-404 -25)" fill="#0A6DB6" fill-rule="nonzero" stroke="none" stroke-width="1"/>
                    </svg>`;
              }
              else if(countryflag == 'in' && settings.can){
                 return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="23" viewBox="0 0 225 150">
                  <rect width="225" height="150" fill="#f93"/><rect width="225" height="50" y="50" fill="#fff"/><rect width="225" height="50" y="100" fill="#128807"/><g transform="translate(112.5,75)"><circle r="20" fill="#008"/><circle r="17.5" fill="#fff"/><circle r="3.5" fill="#008"/><g id="d"><g id="c"><g id="b"><g id="a"><circle r="0.875" fill="#008" transform="rotate(7.5) translate(17.5)"/><path fill="#008" d="M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z"/></g><use xlink:href="#a" transform="rotate(15)"/></g><use xlink:href="#b" transform="rotate(30)"/></g><use xlink:href="#c" transform="rotate(60)"/></g><use xlink:href="#d" transform="rotate(120)"/><use xlink:href="#d" transform="rotate(-120)"/></g>
                  </svg>`;
              }
              else{
                return '';
              }
            })(countryflag)
        }
      </div>

      <div class="tile-img__txt">
        <h5 class="heading heading--fifth heading--dark heading--light">${ settings.heading }</h5>
        ${
          (content => {
            if (content) {
              return `<div class="txt txt--small map_popup">${ content }</div>`
            } else {
              return ''
            }
          })(settings.content)
        }
      </div>
      ${
        (button => {
          if (button.url) {
            return `
            <a href="${ button.url }" class="btn btn--standard btn--blue btn--primary inverse btn--rounded jsLightboxResourceTrigger" target="${ button.target }">
              <span class="btn__inner">${ button.text }</span>
            </a>
            `
          } else {
            return ``
          }
        })(settings.button)
      }
    </div>
  </div>`;
}

export default function () {
  if (mapSection !== undefined && mapSection !== null) {
    let filter = mapSection.querySelector('.jsMapCanadaFilters');
    let mapElement = mapSection.querySelector('.jsMapCanadaMap');
    const dot = {
      path: 'M0,9a9,9 0 1,0 18,0a9,9 0 1,0 -18,0',
      fillColor: '#0079c1',
      fillOpacity: 1,
      strokeWeight: 0,
      size: new google.maps.Size(18, 18),
      anchor: new google.maps.Point(9, 9)
    };

    // Create map
    for (var i = 0; i < document.querySelectorAll('.neo-map-block').length; i++) {
        const location = document.querySelectorAll('.neo-map-block')[i]
        var zoom = parseInt(location.dataset.zoom);
        var lat = parseInt(location.dataset.lat);
        var lng = parseInt(location.dataset.lng);
        var countryflag = location.dataset.flag;
    }

    let map = new google.maps.Map(
        mapElement,
        {
          zoom: zoom,
          center: {
            lat: lat,
            lng: lng
          },
          disableDefaultUI: false,
          styles: light,
          backgroundColor: 'none'
        }
    );

    let infowindow = new google.maps.InfoWindow();

    // Add points
    let markersSettings = [];
    let markers = [];

    for (var i = 0; i < document.querySelectorAll('.map-canada__location').length; i++) {
      const location = document.querySelectorAll('.map-canada__location')[i]

      const button = {
        text: location.dataset.buttontext,
        url: location.dataset.buttonurl,
        target: location.dataset.buttontarget
      }

      const data = {
        lat: parseFloat(location.dataset.lat),
        lng: parseFloat(location.dataset.lng),
        heading: location.dataset.heading,
        content: location.dataset.content,
        button,
        category: location.dataset.category,
        can: location.dataset.can
      }

      markersSettings.push(data)
    }

    for (let i = 0; i < markersSettings.length; i++) {
      markers[i] = new google.maps.Marker({
        position: {
          lat: markersSettings[i].lat,
          lng: markersSettings[i].lng
        },
        map: map,
        icon: dot
      });

      markers[i].addListener('click', function () {
        infowindow.setContent(generateInfo(markersSettings[i], countryflag));
        infowindow.open(map, markers[i]);
      });
    }

    if (filter != undefined) {
      filter.addEventListener('change', function (e) {
        let id = this.querySelector('input:checked').id;
        infowindow.close()

        for (let i = 0; i < markersSettings.length; i++) {
          let category = markersSettings[i].category || '';
          markers[i].setVisible(true);

          if (category !== id && id !== 'all') {
            markers[i].setVisible(false);
          }
        }
      });
    }
  }
}
